import { useFeatureValue } from '@growthbook/growthbook-react';
import { FEATURE_FLAG } from '../constants/featureFlags';
import { buildFtbParticipantLogoUrl } from '../utils/participantLogo';

export const useParticipantLogoUrl = (participantId?: string | null): string | null => {
  const cdnBaseUrl = useFeatureValue<string | null>(FEATURE_FLAG.FTB_PARTICIPANT_LOGO_CDN_BASE_URL, null);

  return buildFtbParticipantLogoUrl(cdnBaseUrl, participantId);
};
